import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

export const Logo = () => {
  const { theme } = useTheme();
  const location = useLocation();

  const handleClick = () => {
    // Scroll to the top when the user is already on the home page.
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Link to="/" className="block" onClick={handleClick}>
      <img src={theme === "dark" ? "/gugudata.ai-white.svg" : "/gugudata.ai-black.svg"} alt="GuGuData.AI" className="h-8 w-auto transition-opacity duration-200 hover:opacity-80" />
    </Link>
  );
};
